import * as rawInvariant from 'invariant';

export const invariant = rawInvariant;



// WEBPACK FOOTER //
// ./src/utils/error-utils.js